import { render } from "./IconRounded.vue?vue&type=template&id=8ad29bf8"
import script from "./IconRounded.vue?vue&type=script&lang=js"
export * from "./IconRounded.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/project-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__